import { ReactNode } from "react";
import { useAppSelector } from "../../../app/hooks";
import { FeatureFlagName } from "../../../app/featureFlags/featureFlags";
import { canViewFeature } from "../../../app/featureFlags/helpers";

type Props = {
  name: FeatureFlagName;
  children: ReactNode;
  fallback?: ReactNode;
};

const FeatureFlag = ({ name, children, fallback = null }: Props) => {
  const user = useAppSelector((state) => state.user.user);
  const enabled = canViewFeature(name, user);
  return <>{enabled ? children : fallback}</>;
};

export default FeatureFlag;
